import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["configFields", "channelType", "slackMissing"]

  connect() {
    if (this.hasChannelTypeTarget) {
      this.updateConfigFields()
    }
  }

  onChannelTypeChange() {
    this.updateConfigFields()
  }

  updateConfigFields() {
    if (!this.hasChannelTypeTarget) return
    const channelType = this.channelTypeTarget.value
    if (!channelType) {
      this.configFieldsTarget.innerHTML = ""
      this.configFieldsTarget.classList.add("hidden")
      this.toggleSubmit(true)
      return
    }

    this.configFieldsTarget.classList.remove("hidden")

    fetch(`/notification_channels/config_fields?channel_type=${channelType}`, {
      headers: {
        "Accept": "text/html",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then(response => response.text())
      .then(html => {
        this.configFieldsTarget.innerHTML = html
        this.toggleSubmit(!this.hasSlackMissingTarget)
      })
      .catch(error => {
        console.error("Failed to load config fields:", error)
      })
  }

  toggleSubmit(enabled) {
    const submit = this.element.querySelector('[type="submit"]')
    if (!submit) return
    submit.disabled = !enabled
    submit.classList.toggle("opacity-50", !enabled)
    submit.classList.toggle("cursor-not-allowed", !enabled)
  }
}
